import {
  Alert02Icon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  Calendar03Icon,
  Cancel01Icon,
  Delete02Icon,
  Download04Icon,
  DragDropVerticalIcon,
  Edit02Icon,
  Key01Icon,
  Logout03Icon,
  PlusSignIcon,
  RefreshIcon,
  Search01Icon,
  Settings02Icon,
  SquareLock02Icon,
  SquareUnlock02Icon,
  Tick02Icon,
  Upload04Icon,
  UserAdd01Icon,
  UserCircleIcon,
  UserGroupIcon,
  ViewIcon,
  ViewOffIcon,
} from '@hugeicons/core-free-icons'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'

/** The console's icon registry: keys name the meaning (pwa_starter rule 1). */
export const ICON_REGISTRY = {
  attendance: Calendar03Icon,
  members: UserGroupIcon,
  accounts: UserCircleIcon,
  settings: Settings02Icon,
  back: ArrowLeft01Icon,
  forward: ArrowRight01Icon,
  up: ArrowUp01Icon,
  down: ArrowDown01Icon,
  add: PlusSignIcon,
  addUser: UserAdd01Icon,
  edit: Edit02Icon,
  delete: Delete02Icon,
  check: Tick02Icon,
  close: Cancel01Icon,
  search: Search01Icon,
  alert: Alert02Icon,
  retry: RefreshIcon,
  logout: Logout03Icon,
  lock: SquareLock02Icon,
  unlock: SquareUnlock02Icon,
  key: Key01Icon,
  export: Download04Icon,
  import: Upload04Icon,
  drag: DragDropVerticalIcon,
  show: ViewIcon,
  hide: ViewOffIcon,
} satisfies Record<string, IconSvgElement>

export type IconName = keyof typeof ICON_REGISTRY

export function AppIcon({
  name,
  size = 20,
  strokeWidth = 1.75,
}: {
  name: IconName
  size?: 16 | 20 | 24
  strokeWidth?: number
}) {
  return (
    <HugeiconsIcon
      icon={ICON_REGISTRY[name]}
      size={size}
      color="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
    />
  )
}
